module.exports = {"title":"Forgot your password?","content":"<p>Please go back to the Homepage or use the Navigation.</p>","username":"Username","submit":"Submit","msg":{"yay":"Yay!","oops":"Oops!","success":"Email sent successfully, please check your inbox"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/locales/fr.json
// module id = 1763
// module chunks = 0